// Helper used by CommentThread + InlineSelect when running in embedded
// (sheet) mode. Sends a CSRF-authenticated fetch instead of going
// through Inertia's router, so the comment / status PATCH does NOT
// trigger an Inertia navigation that would unmount the index page (and
// the sheet) on the server's redirect_to task_path(@task).
//
// We discard the response body — the sheet's own re-fetch + a
// router.reload of the index list (see TaskDetailSheet#reload) bring
// fresh data once the request completes.
//
// CSRF strategy: Rails accepts either X-CSRF-Token (matches the
// per-page <meta name="csrf-token"> value) OR X-XSRF-TOKEN (matches
// the XSRF-TOKEN cookie, URL-decoded — same convention Axios/Inertia
// use). The page-rendered meta token can desync from the session
// token after sign-in / Devise rotations, so we read the cookie too
// and send both headers; Rails uses whichever passes.

function readXsrfTokenFromCookie(): string {
  const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/)
  if (!match) return ''
  try {
    return decodeURIComponent(match[1])
  } catch {
    return match[1]
  }
}

export async function sheetFetch(
  url: string,
  options: { method?: 'POST' | 'PATCH' | 'DELETE'; body?: unknown } = {},
): Promise<Response> {
  const metaToken =
    document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? ''
  const cookieToken = readXsrfTokenFromCookie()

  const headers: Record<string, string> = {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  }
  if (metaToken) headers['X-CSRF-Token'] = metaToken
  if (cookieToken) headers['X-XSRF-TOKEN'] = cookieToken
  if (options.body !== undefined) headers['Content-Type'] = 'application/json'

  const init: RequestInit = {
    method: options.method ?? 'POST',
    credentials: 'same-origin',
    headers,
    redirect: 'follow',
  }
  if (options.body !== undefined) {
    init.body = JSON.stringify(options.body)
  }

  return fetch(url, init)
}
